export enum NavigationEndpoint {
  recordings = 'recordings',
  clips = 'clips',
  text = 'text',
  social = 'social',
  blog = 'blog',
  email = 'email',
  takeaways = 'takeaways',
  custom = 'custom'
}
